import { render } from "./AboutUsSectionTwoCMS.vue?vue&type=template&id=dd6e9084&scoped=true"
import script from "../js/about-us-section-two-cms.js?vue&type=script&lang=js"
export * from "../js/about-us-section-two-cms.js?vue&type=script&lang=js"

import "./AboutUsSectionTwoCMS.vue?vue&type=style&index=0&id=dd6e9084&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6e9084"]])

export default __exports__